import Adobe from "../providers/adobe";
import { PML } from "../providers/pml";
import TikTok from "../providers/tikTok";
import Facebook from "../providers/facebook";
import AlPrestamo from "../providers/alprestamo";
import FloodlightActivities from "../providers/floodlightActivities";
import { GoogleRMKT, GoogleSiteTag, GoogleAds } from "../providers/google";

import * as MUTATIONS from "../../config/constants/mutation-types";

const pixelDb = {
  triggers: {
    [MUTATIONS.ON_ROUTE]: {
      consulta: [
        "Adobe.consulta",
        "GoogleRMKT.landing",
        "GoogleRMKT.enviar",
        "GoogleSiteTag.landing",
        "Facebook.landing",
        "FloodlightActivities.landing",
        "TikTok.consulta"
      ],
      ofertaCA: [
        "Adobe.ofertaCA",
        "GoogleRMKT.ofertaCA",
        "GoogleRMKT.enviar",
        "GoogleSiteTag.snippetOfertaCA",
        "Facebook.ofertaCA",
        "FloodlightActivities.ofertaCA"
      ],
      renaperConfirmar: ["Adobe.renaperConfirmar"],
      renaperConsultar: ["Adobe.renaperConsultar"],
      sucursal: [
        "Adobe.sucursal",
        "GoogleRMKT.sucursal",
        "GoogleRMKT.enviar",
        "GoogleSiteTag.snippetSucursal",
        "Facebook.sucursal",
        "FloodlightActivities.sucursal"
      ],
      graciasCA: [
        "Adobe.gracias",
        "GoogleRMKT.thankYouCA",
        "GoogleRMKT.enviar",
        "GoogleSiteTag.snippetThankCA",
        "Facebook.thankYouCA",
        "FloodlightActivities.thankYouCA"
      ],
      mensaje: ["Adobe.mensaje"],
      continuaSucursal: ["Adobe.continuaSucursal"],
      // Camino 1
      ofertaCuenta: [
        "Adobe.ofertaCuenta",
        "Facebook.ofertaCuenta",
        "GoogleSiteTag.snippetOfertaCuenta",
        "TikTok.oferta"
      ],
      datosPersonales: ["Adobe.datosPersonales"],
      datosLaborales: ["Adobe.datosLaborales"],
      informacionAdicional: ["Adobe.informacionAdicional"],
      identidad: ["Adobe.identidad"],
      loadingVeridas: ["Adobe.loadingVeridas"],
      biometriaOK: ["Adobe.biometriaOK"],
      configuracion: ["Adobe.configuracion"],
      contrato: ["Adobe.contrato"],
      thank: [
        "Adobe.graciasCajaAhorro",
        "TikTok.graciasCajaAhorro",
        "Facebook.graciasCajaAhorro",
        "GoogleAds.graciasCajaAhorro",
        "GoogleSiteTag.snippetGraciasCajaAhorro"
      ],
      // Camino 2
      oferta: [
        "Adobe.oferta",
        "GoogleRMKT.oferta",
        "GoogleRMKT.enviar",
        "GoogleSiteTag.snippetOferta",
        "Facebook.oferta",
        "FloodlightActivities.oferta",
        "TikTok.oferta",
        "PML.enviarOfertaPq"
      ],
      paso1: [
        "Adobe.paso1",
        "GoogleRMKT.paso1",
        "GoogleRMKT.enviar",
        "GoogleSiteTag.snippetPaso1",
        "Facebook.paso1",
        "FloodlightActivities.paso1",
        "TikTok.paso1"
      ],
      paso2: [
        "Adobe.paso2",
        "GoogleRMKT.paso2",
        "GoogleRMKT.enviar",
        "GoogleSiteTag.snippetPaso2",
        "Facebook.paso2",
        "FloodlightActivities.paso2",
        "TikTok.paso2"
      ],
      paso3: [
        "Adobe.paso3",
        "GoogleRMKT.paso3",
        "GoogleRMKT.enviar",
        "GoogleSiteTag.snippetPaso3",
        "Facebook.paso3",
        "FloodlightActivities.paso3",
        "TikTok.paso3"
      ],
      paso4: [
        "Adobe.paso4",
        "GoogleRMKT.paso4",
        "GoogleRMKT.enviar",
        "GoogleSiteTag.snippetPaso4",
        "Facebook.paso4",
        "FloodlightActivities.paso4",
        "TikTok.paso4"
      ],
      gracias: [
        "Adobe.gracias",
        "GoogleRMKT.thankYou",
        "GoogleRMKT.enviar",
        "GoogleSiteTag.snippetThank",
        "Facebook.thankYou",
        "FloodlightActivities.thankYou",
        "PML.enviar",
        "TikTok.thank",
        "AlPrestamo.enviar"
      ],
      // Camino 3
      cliente: [
        "Adobe.cliente",
        "GoogleRMKT.cliente",
        "GoogleRMKT.enviar",
        "GoogleSiteTag.snippetCliente",
        "Facebook.cliente",
        "FloodlightActivities.cliente",
        "TikTok.cliente"
      ],
      // Camino 4
      confirmar: ["Adobe.confirmar"],
      noCliente: [
        "Adobe.noCliente",
        "GoogleRMKT.noCliente",
        "GoogleRMKT.enviar",
        "GoogleSiteTag.snippetNoCliente",
        "Facebook.noCliente",
        "TikTok.noCliente"
      ],
      // Camino 5
      clienteCA: ["Adobe.clienteCA"],
      celular: ["Adobe.celular"],
      usuarioClave: ["Adobe.usuarioClave"],
      thankOTP: ["Adobe.thankOTP"]
    },
    [MUTATIONS.ADOBE_APP_STARTED]: ["Adobe.appStartedClick"],
    [MUTATIONS.ADOBE_APP_ON_CLICK_START]: [],
    [MUTATIONS.ON_INTERNAL_LINK]: ["Adobe.internalLink"],
    [MUTATIONS.ON_INGRESO_BANCA_ONLINE]: ["Adobe.ingresoBancaOnline"]
  },
  providers: {
    PML,
    Adobe,
    TikTok,
    Facebook,
    GoogleAds,
    GoogleRMKT,
    AlPrestamo,
    GoogleSiteTag,
    FloodlightActivities
  }
};

export default pixelDb;
